<template>

  <v-container>
    <v-row justify="center">
      <v-col sm="8" md="6" lg="4" xl="3">
        
        <div class="panel panel--compact panel-landing-income">
            
            <div v-if="showSecondPart == false">

                <!-- Title/info -->   
                <div class="panel__subtitle text-center mb-2">
                    {{ publicStore.Income.IsSP ? "V spodnje polje vnesite svoje mesečne prihodke." : "V spodnje polje vnesite svoj mesečni prihodek." }} <br/>
                </div>
                
                <div class="form-info-text text-center mb-10" v-html="publicStore.Income.IsSP ? 'Vnesite svojo plačo ali pokojnino skupaj z dodatki za prehrano in prevoz. Te podatke potrebujemo za sklenitev pogodbe za nakup na obroke.' : 'Vnesite svojo plačo ali pokojnino skupaj z dodatki za prehrano in prevoz. Ta podatek potrebujemo za sklenitev pogodbe za nakup na obroke.'" ></div>
                
                <!-- Sign in form -->
                <v-form>
                    
                    <!--Mesečni prihodek -->
                    <div>
                        <label class="form-label">
                            {{ publicStore.Income.IsSP ? $t(`Components.InstallmentPlanComponent.MonthlyIncome`) + "- " + $t(`Components.InstallmentPlanComponent.Months.` + pastMonths.month0.toString()) : $t(`Components.InstallmentPlanComponent.LastMonthlyIncome`) }}
                        </label>
                        <!-- <v-number-input
                            v-model="v$.IncomeOne.$model"
                            :numberOfDecimals="2"
                            :error-messages="v$.IncomeOne.$errors[0] != null ? v$.IncomeOne.$errors[0].$message : ''"
                            @focus="v$.IncomeOne.$reset" 
                            :reverse="false"
                            controlVariant="default"
                            label=""
                            :hideInput="false"
                            :inset="false"
                            variant="outlined"
                            append-inner-icon="mdi-currency-eur"
                        ></v-number-input> -->
                        <NumericInput
                            v-model="v$.IncomeOne.$model"
                            :numberOfDecimals="2"
                            :error-messages="v$.IncomeOne.$errors[0] != null ? v$.IncomeOne.$errors[0].$message : ''"
                            @focus="v$.IncomeOne.$reset" 
                            variant="outlined"
                            append-inner-icon="mdi-currency-eur" >
                        </NumericInput>
                    </div>

                    <div v-if="publicStore.Income.IsSP">
                        <label class="form-label">
                            {{ $t(`Components.InstallmentPlanComponent.MonthlyIncome`) + "- " + $t(`Components.InstallmentPlanComponent.Months.` + pastMonths.month1.toString()) }}
                        </label>

                        <!-- <v-number-input
                            v-model="v$.IncomeTwo.$model"
                            :numberOfDecimals="2"
                            :error-messages="v$.IncomeTwo.$errors[0] != null ? v$.IncomeTwo.$errors[0].$message : ''"
                            @focus="v$.IncomeTwo.$reset" 
                            variant="outlined"
                            append-inner-icon="mdi-currency-eur"
                            :reverse="false"
                            controlVariant="default"
                            label=""
                            :hideInput="false"
                            :inset="false"
                        ></v-number-input> -->
                        <NumericInput
                            v-model="v$.IncomeTwo.$model"
                            :numberOfDecimals="2"
                            :error-messages="v$.IncomeTwo.$errors[0] != null ? v$.IncomeTwo.$errors[0].$message : ''"
                            @focus="v$.IncomeTwo.$reset" 
                            variant="outlined"
                            append-inner-icon="mdi-currency-eur" >
                        </NumericInput>

                        <label class="form-label">
                            {{ $t(`Components.InstallmentPlanComponent.MonthlyIncome`) + "- " + $t(`Components.InstallmentPlanComponent.Months.` + pastMonths.month2.toString()) }}
                        </label>

                        <!-- <v-number-input
                            v-model="v$.IncomeThree.$model"
                            :numberOfDecimals="2"
                            :error-messages="v$.IncomeThree.$errors[0] != null ? v$.IncomeThree.$errors[0].$message : ''"
                            @focus="v$.IncomeThree.$reset" 
                            variant="outlined"
                            append-inner-icon="mdi-currency-eur" 
                            :reverse="false"
                            controlVariant="default"
                            label=""
                            :hideInput="false"
                            :inset="false"
                        ></v-number-input> -->
                        <NumericInput
                            v-model="v$.IncomeThree.$model"
                            :numberOfDecimals="2"
                            :error-messages="v$.IncomeThree.$errors[0] != null ? v$.IncomeThree.$errors[0].$message : ''"
                            @focus="v$.IncomeThree.$reset" 
                            variant="outlined"
                            append-inner-icon="mdi-currency-eur" >
                        </NumericInput>
                    </div>

                    <v-checkbox
                        v-model="v$.ConfirmSalary.$model"
                        :error-messages="v$.ConfirmSalary.$errors[0] != null ? v$.ConfirmSalary.$errors[0].$message : ''"
                        @focus="v$.ConfirmSalary.$reset"
                        label="Potrjujem, da so podatki o prihodku pravilni."
                    ></v-checkbox>
                                    
                    <v-btn @click="sendIncome(id)" size="large" block class="btn btn--primary-fill"> {{ publicStore.Income.IsSP ?  "Pošlji podatke" :  "Pošlji podatek" }}</v-btn>
                    
                </v-form>
                
            </div>
            
        <div v-else>
            <div class="text-center mb-10" v-html="publicStore.Income.IsSP ? 'Hvala.<br/>Uspešno ste vnesli svoje mesečne prihodke.' : 'Hvala.<br/>Uspešno ste vnesli svoj mesečni prihodek.'"></div>
        </div>
    </div>
      </v-col>
      
    </v-row>
    
  </v-container>
  
</template>

<script setup lang="ts">
    import { computed, Ref, ref } from "vue";
    import { usePublicStore } from "@publicstore/store";
    import { useVuelidate } from "@vuelidate/core";
    import errors  from "@/app/global-errors";
    import { helpers, requiredIf, sameAs } from "@vuelidate/validators";
    import { i18n } from "@app/i18n";
    import NumericInput from "@components/numeric-input.vue";
    // import { VNumberInput } from 'vuetify/labs/VNumberInput'

    const props = defineProps({
        id: {
            type: String,
            required: true
        }
    });

    const publicStore = usePublicStore();

    publicStore.IncomeInsertGetSP(props.id);

    // Returns objects with the names of the last three months and the current month (numerically, 0–11), for UI display.
    const pastMonths = computed(() => {
        const currMonth = new Date().getMonth()
        return {
          month0: currMonth > 2 ? currMonth - 3 : currMonth + 9,
          month1: currMonth > 1 ? currMonth - 2 : currMonth + 10,
          month2: currMonth > 0 ? currMonth - 1 : currMonth + 11,
          month3: currMonth
        }
    });

    //Validation
    async function validateForm(): Promise<void>{
        v$.value.$touch();
        let formValid = await v$.value.$validate();                
        return new Promise((resolve) => {                
            if(formValid){
                resolve();
            }
        });                                                                       
    };

    let showSecondPart: Ref<boolean> = ref(false);
    
    async function sendIncome(id: string) {
        await validateForm().then(() => {
            v$.value.$reset();
            publicStore.insertIncome(id);
            showSecondPart.value = true;
        });
    }

    const validationRules = computed(() => ({
        IncomeOne: {
            required: errors.fieldRequired
        },
        IncomeTwo: {
            required: helpers.withMessage(i18n.global.t("GlobalErrors.FIELD_REQUIRED"), requiredIf(publicStore.Income.IsSP))
        },
        IncomeThree: {
            required: helpers.withMessage(i18n.global.t("GlobalErrors.FIELD_REQUIRED"), requiredIf(publicStore.Income.IsSP))
        },
        ConfirmSalary: {
            required: helpers.withMessage(i18n.global.t("GlobalErrors.FIELD_REQUIRED"), sameAs(true)),
        },
    }));

    const v$: any = useVuelidate(validationRules, publicStore.Income.IncomeData);

</script>